// Drivers API client — Phase 4 Plan 04-03 (DIS-05).
//
// Wraps:
//   GET  /api/v1/drivers                       (paginated list with status)
//   POST /api/v1/drivers/{driver_id}/deactivate (soft-delete)

import type { ApiClient } from "./client";

export type DriverStatus = "online" | "offline" | "on_trip";

export interface DriverListItem {
  id: number;
  full_name: string | null;
  phone: string | null;
  status: DriverStatus;
  last_seen_at: string | null;
}

export interface DriversListResponse {
  items: DriverListItem[];
  total: number;
  offset: number;
  limit: number;
}

export interface DriversListFilters {
  status?: "online" | "offline" | "on_trip" | "all";
  search?: string;
  offset?: number;
  limit?: number;
}

export interface DeactivateDriverResponse {
  driver_id: number;
  deactivated: boolean;
}

function _buildQuery(filters: DriversListFilters): string {
  const p = new URLSearchParams();
  if (filters.status && filters.status !== "all") p.set("status", filters.status);
  if (filters.search) p.set("search", filters.search);
  if (filters.offset !== undefined) p.set("offset", String(filters.offset));
  if (filters.limit !== undefined) p.set("limit", String(filters.limit));
  const s = p.toString();
  return s ? `?${s}` : "";
}

export const driversApi = {
  list(client: ApiClient, filters: DriversListFilters = {}): Promise<DriversListResponse> {
    return client.get<DriversListResponse>(`/api/v1/drivers${_buildQuery(filters)}`);
  },

  deactivate(client: ApiClient, driverId: number): Promise<DeactivateDriverResponse> {
    return client.post<DeactivateDriverResponse>(`/api/v1/drivers/${driverId}/deactivate`, {});
  },
};
